document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }, 2500);
    setTimeout(function () {
      revealEls.forEach(function (el) {
        if (getComputedStyle(el).opacity === '0') {
          el.style.animation = 'none';
          el.style.opacity = '1';
        }
      });
    }, 4000);
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  var header = document.getElementById('site-header');
  function onScroll() {
    if (window.scrollY > 20) {
      header.classList.add('bg-white/90', 'backdrop-blur-sm', 'shadow-sm');
      header.classList.remove('bg-transparent');
    } else {
      header.classList.remove('bg-white/90', 'backdrop-blur-sm', 'shadow-sm');
      header.classList.add('bg-transparent');
    }
  }
  window.addEventListener('scroll', onScroll);
  onScroll();

  var menuBtn = document.getElementById('mobile-menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      mobileMenu.classList.toggle('hidden');
      mobileMenu.classList.toggle('flex');
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.add('hidden');
        mobileMenu.classList.remove('flex');
      });
    });
  }

  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-btn');
    var panel = item.querySelector('.faq-panel');
    var icon = item.querySelector('.faq-icon');
    btn.addEventListener('click', function () {
      var isOpen = panel.classList.contains('open');
      document.querySelectorAll('.faq-panel.open').forEach(function (p) {
        p.classList.remove('open');
        p.parentElement.querySelector('.faq-icon').classList.remove('open');
      });
      if (!isOpen) {
        panel.classList.add('open');
        icon.classList.add('open');
      }
    });
  });

  var counters = document.querySelectorAll('.counter');
  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-target'), 10);
        var duration = 1600;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          el.textContent = Math.floor(progress * target).toLocaleString('es-ES');
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString('es-ES');
        }
        requestAnimationFrame(step);
        counterObserver.unobserve(el);
      }
    });
  }, { threshold: 0.5 });
  counters.forEach(function (el) { counterObserver.observe(el); });
  setTimeout(function () {
    counters.forEach(function (el) {
      if (el.textContent === '0') el.textContent = parseInt(el.getAttribute('data-target'), 10).toLocaleString('es-ES');
    });
  }, 3000);
});
